import { createContext, useEffect, useState } from "react";
import i18next from "i18next";
import { convertLanguageCode } from "shared/utils/Utils";
import { isMobile as isMobileBrowser } from "react-device-detect";
import { useLocation } from "react-router-dom";
import { Cookie, deleteCookie } from "shared/StoreRequester";
import { useDispatch } from "react-redux";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";

export const BrowserDetectContext = createContext({
  isMobile: Boolean,
  deviceType: String, // "mobile" | "tablet" | "pc"
  width: Number,
  languageCode: String,
  locationHistory: Array,
  currentNavigationDirection: String,
});

function BrowserEventProvider(props) {
  const mode =
    (typeof window !== "undefined"
      ? window.sessionStorage.getItem("mode")
      : 0) || 0;
  const location = useLocation();
  const dispatch = useDispatch();
  // 브레이크포인트 정의
  const MOBILE_MAX_WIDTH = 768;
  const TABLET_MAX_WIDTH = 1024;

  const initialWidth = typeof window !== "undefined" ? window.innerWidth : 1024;

  // 초기 deviceType 결정 함수
  const getDeviceType = (width) => {
    if (width <= MOBILE_MAX_WIDTH) return "mobile";
    if (width <= TABLET_MAX_WIDTH) return "tablet";
    return "pc";
  };

  // 모드나 디바이스 감지에 따른 deviceType 계산(우선순위: mode > 실제width)
  const calcDeviceType = (mode, width) => {
    if (mode === "1") {
      return "pc";
    } else if (mode === "2") {
      return "mobile";
    } else {
      // 디바이스 자동감지
      // isMobileBrowser 옵션 고려
      // 모바일 브라우저 감지되면 'mobile' 우선, 아니면 width로 판단
      if (isMobileBrowser && width <= MOBILE_MAX_WIDTH) {
        return "mobile";
      }
      return getDeviceType(width);
    }
  };

  const [width, setWidth] = useState(initialWidth);
  const [deviceType, setDeviceType] = useState(calcDeviceType(mode, initialWidth));
  const [isMobile, setMobile] = useState(deviceType === "mobile");

  const [languageCode, setLanguageCode] = useState(
    convertLanguageCode(i18next.language)
  );
  const [locationHistory, setLocationHistory] = useState([location.pathname]);
  const [currentNavigationDirection, setNavigationDirection] = useState(null);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    i18next.on("languageChanged", (e) => {
      setLanguageCode(convertLanguageCode(e));
    });
    window.addEventListener("storage", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("storage", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (locationHistory[locationHistory.length - 1] !== location.pathname) {
      setLocationHistory((prev) => [...prev, location.pathname]);
      setNavigationDirection("FORWARD");
    } else if (
      locationHistory[locationHistory.length - 2] === location.pathname
    ) {
      setLocationHistory((prev) => prev.slice(0, -1));
      setNavigationDirection("BACKWARD");
    }
  }, [location]);

  const handleWindowSizeChange = () => {
    const mode =
      (typeof window !== "undefined"
        ? window.sessionStorage.getItem("mode")
        : 0) || 0;

    const newWidth = window.innerWidth;
    const newDeviceType = calcDeviceType(mode, newWidth);

    setDeviceType(newDeviceType);
    setMobile(newDeviceType === "mobile");
    setWidth(newWidth);
  };
  // useEffect(() => {
  //   deleteCookie(Cookie.JWT)
  //   dispatch(AuthReducer.actions.reset());
  // }, [isMobile])
  return (
    <BrowserDetectContext.Provider
      value={{
        isMobile,
        deviceType, // 새로운 deviceType 상태 공개
        width,
        languageCode,
        locationHistory,
        currentNavigationDirection,
      }}
    >
      {props.children}
    </BrowserDetectContext.Provider>
  );
}

export default BrowserEventProvider;
